// Simple range function
//
// example: range(0, 100, 20) -> [0, 20, 40, 60, 80, 100]
//
export const range = (start, stop, step) => {
  const a = [start];
  let b = start;
  while (b < stop) {
    a.push((b += step || 1));
  }
  return a;
};
